@if (appSettings.isMobile()) {
	<nav class="bottom-nav" aria-label="Navegación principal">
		<button type="button"
			class="bottom-nav-item"
			[class.active]="sheet() === 'notices'"
			[class.bottom-nav-item-muted]="nav.badgeCount() === 0"
			(click)="toggleSheet('notices', $event)">
			<i class="fa fa-bell"></i>
			<span class="bottom-nav-label">Avisos</span>
			@if (nav.badgeCount() > 0) {
				<span class="bottom-nav-badge">{{ nav.noticesBadgeLabel() }}</span>
			}
		</button>

		<button type="button"
			class="bottom-nav-item"
			[class.active]="sheet() === 'roles'"
			[title]="nav.roleSelectedLabel()"
			(click)="toggleSheet('roles', $event)">
			<i class="fa fa-user-tag"></i>
			<span class="bottom-nav-label">Rol</span>
			<span class="bottom-nav-badge">{{ nav.rolesBadgeLabel() }}</span>
		</button>

		<button type="button"
			class="bottom-nav-item"
			[class.active]="appSettings.appSidebarMobileToggled"
			(click)="openMenu()"
			aria-label="Abrir menú">
			<i class="fa fa-bars"></i>
			<span class="bottom-nav-label">Menú</span>
		</button>
	</nav>

	<app-bottom-sheet
		[open]="!!sheet()"
		[title]="sheet() === 'roles' ? 'Cambiar rol' : (sheet() === 'notices' ? 'Notificaciones' : '')"
		(closed)="closeSheet()">
		@if (sheet() === 'notices' && nav.hub.unreadCount() > 0) {
			<span sheetTitle class="badge bg-primary ms-2">{{ nav.hub.unreadCount() }} nuevas</span>
		}
		@if (sheet() === 'notices') {
			@if (nav.recentNotices().length > 0) {
				<div class="bottom-sheet-label">Avisos recientes</div>
				@for (notice of nav.recentNotices(); track notice.key) {
					<button type="button" class="bottom-sheet-item" [class.fw-semibold]="!notice.read" (click)="nav.hub.open(notice); closeSheet()">
						<span class="bottom-sheet-item-title">
							@if (!notice.read) {
								<span class="notice-dot"></span>
							}
							{{ notice.title }}
						</span>
						<span class="bottom-sheet-item-text">{{ notice.message }}</span>
						<span class="bottom-sheet-item-meta">{{ notice.at | date:'short' }}</span>
					</button>
				}
			}
			@if (nav.pendingRequests().length > 0) {
				<div class="bottom-sheet-label">Pendientes de tus roles</div>
				@for (item of nav.pendingRequests(); track item.request.uuid) {
					<button type="button" class="bottom-sheet-item" (click)="openPending(item)">
						<span class="bottom-sheet-item-title">{{ nav.processName(item) }}</span>
						<span class="bottom-sheet-item-text">{{ nav.partyLabel(item) }}</span>
						<span class="bottom-sheet-item-meta">{{ nav.pendingRoleLabel(item) }} · {{ nav.createdAt(item) | date:'short' }}</span>
					</button>
				}
			}
			@if (nav.recentNotices().length === 0 && nav.pendingRequests().length === 0) {
				<div class="bottom-sheet-empty">No hay notificaciones pendientes</div>
			} @else {
				<button type="button" class="bottom-sheet-item bottom-sheet-link" (click)="openInbox()">
					Ver bandeja de solicitudes
				</button>
			}
		}
		@if (sheet() === 'roles') {
			@for (r of nav.rolesList(); track r.id) {
				<button type="button" class="bottom-sheet-item" [class.active]="nav.isActiveRole(r)" (click)="selectRole(r)">
					<span class="bottom-sheet-item-title">{{ r.displayName || r.description || r.name }}</span>
					@if (nav.isActiveRole(r)) {
						<span class="bottom-sheet-item-meta text-info">Rol activo</span>
					}
				</button>
			}
		}
	</app-bottom-sheet>
}
